// import React, { FC, useEffect, useRef } from 'react'
// import { useGetInfinityPostFeed } from '@services/posts/hooks/useGetPostsFeed'
// import { PageQueries } from '@specs/navigation'
// import { useRouter } from 'next/router'
// import { Grid } from '@components/Grids/Grid'
// import { api } from '@api'
// import { PostCardPreview } from '@components/Cards/PostCard/PostCardPreview'
// import { EmptyProfile } from '@components/Pages/ProfilePages/EmptyProfile/EmptyProfile'

// type PersonalListProps = {
//     isMobile: boolean
//     isMyProfile: boolean
//     profileId: number
// }

// const limit = 5

// /**
//  * Публичная компонента для отображения списка постов пользователя
//  */

// export const AuthorPostFeedList: FC<PersonalListProps> = ({ isMobile, isMyProfile, profileId }) => {
//     const utils = api.useUtils()
//     const enabledRef = useRef(false)
//     const router = useRouter()

//     const { query }: PageQueries = router.query

//     const {
//         data,
//         fetchNextPage,
//         hasNextPage,
//         isFetchingNextPage,
//         status,
//     } = useGetInfinityPostFeed({ limit, query, published: true, author_id: profileId }, {
//         enabled: enabledRef.current,
//     })

//     const fetchNext = async () => { await fetchNextPage() }

//     useEffect(() => {
//         if (!data) return
//         data.pages.map(({ items }) => items.map(post => (
//             utils.PostsManager.getPost.setData({ post_id: post.id }, post)
//         )))
//     }, [data])

//     return (
//         <div>
//             <Grid
//                 data={data}
//                 enabledRef={enabledRef}
//                 isFetchingNextPage={isFetchingNextPage}
//                 hasNextPage={hasNextPage}
//                 fetchNext={fetchNext}
//                 status={status}
//                 limit={limit}
//                 gridVariant='feed'
//                 skipFirstBanner
//                 showBanners={false}
//                 EmptyComponent={() => <EmptyProfile isMyProfile={isMyProfile} pageType={'posts'} />}
//             >
//                 {post => <PostCardPreview isMobile={isMobile} key={post.id} initialPost={post} />}
//             </Grid>
//         </div>
//     )
// }

import React, { FC, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { EmptyProfile } from '@components/Pages/ProfilePages/EmptyProfile/EmptyProfile';
import { PaginatedGrid } from '@components/Grids/PaginatedGrid';
import { PostCardPreview } from '@components/Cards/PostCard/PostCardPreview';
import { useGetPostsFeed } from '@services/posts/hooks/useGetPostsFeed';
import { PageQueries } from '@specs/navigation';
import { api } from '@api';
type AuthorListProps = {
  isMobile: boolean;
  isMyProfile: boolean;
  profileId: number;
};
const limit = 5;
export const AuthorPostFeedList: FC<AuthorListProps> = ({
  isMobile,
  isMyProfile,
  profileId
}) => {
  const router = useRouter();
  const utils = api.useUtils();
  const gridRef = useRef<HTMLDivElement>(null);
  const {
    query,
    page = '1'
  }: PageQueries = router.query;
  const currentPage = Number(page);
  const prevPageRef = useRef<number>(currentPage);
  const pageChangeRef = useRef(false);
  const {
    data,
    status
  } = useGetPostsFeed({
    limit,
    skip: (currentPage - 1) * limit,
    query,
    published: true,
    author_id: profileId
  }, {
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: true
  });
  const handlePageChange = (newPage: number) => {
    pageChangeRef.current = true;
    router.push({
      query: {
        ...router.query,
        page: newPage.toString()
      }
    }, undefined, {
      scroll: false
    });
  };
  useEffect(() => {
    if (currentPage !== prevPageRef.current) {
      pageChangeRef.current = true;
      prevPageRef.current = currentPage;
    }
    if (pageChangeRef.current && status === 'success' && data?.items.length) {
      if (gridRef.current) {
        window.scrollTo({
          top: gridRef.current.offsetTop - 100,
          behavior: 'smooth'
        });
      }
      pageChangeRef.current = false;
    }
  }, [currentPage, status, data]);
  useEffect(() => {
    if (!data?.items) return;
    data.items.forEach(post => {
      utils.PostsManager.getPost.setData({
        post_id: post.id
      }, post);
    });
  }, [data]);
  return <div ref={gridRef} data-sentry-component="AuthorPostFeedList" data-sentry-source-file="AuthorPostFeedList.tsx">
            <PaginatedGrid data={data} currentPage={currentPage} onPageChange={handlePageChange} status={status} gridVariant='feed' skipFirstBanner showBanners={isMobile} EmptyComponent={() => <EmptyProfile isMyProfile={isMyProfile} pageType={'posts'} />} data-sentry-element="PaginatedGrid" data-sentry-source-file="AuthorPostFeedList.tsx">
                {post => <PostCardPreview isMobile={isMobile} key={post.id} initialPost={post} />}
            </PaginatedGrid>
        </div>;
};